<template>
   <UApp>
   <NuxtLayout>
      <NuxtPage  />
   </NuxtLayout>
   </UApp>
</template>

<script setup  lang="ts">

</script>



